module.exports = __webpack_public_path__ + "img/third.f92cadd0.jpg";